import "./Spinner.css";
const Spinner = (props: { small?: boolean }) => <div className={`spinner ${props.small ? "small" : ""}`}></div>;
export default Spinner;
